export type PageSize = 20 | 50 | 100;
export const pageSizeOptions: PageSize[] = [20, 50, 100];
export const pageSizeSelectOptions = pageSizeOptions.map((size) => ({
  variant: "text" as const,
  label: size.toString(),
  value: size,
}));
